'use strict';
import angular from 'angular';
import $ from 'jquery';
import initAngularTemplatedDirectives from 'coreModules/shared/scripts/app.services';

angular.module('app.ctrls')
    .controller('AppController', AppController)
    .controller('NavController', NavController)
    .controller('RightFrameController', RightFrameController)
    .controller('FooterController', FooterController);

/**
 * @ngInject
 */
function AppController(
    $rootScope,
    $templateCache,
    $scope,
    $timeout,
    UIFactory,
    AppFactory,
    DateRangeFactory,
    DashboardFilterPanelFactory,
    NavMainFactory,
    navItems,
    daterange,
    dataTypes,
    services,
    relativeDateRanges,
    themeColors,
    brandMappings
) {
    var mm = window.matchMedia('(max-width: 767px)');
    $rootScope.isMobile = mm.matches ? true: false;

    $rootScope.safeApply = function(fn) {
        var phase = this.$root.$$phase;
        if(phase == '$apply' || phase == '$digest') {
            if(fn && (typeof(fn) === 'function')) {
                fn();
            }
        } else {
            this.$apply(fn);
        }
    };

    // Has content done loading onto a page
    $rootScope.contentLoaded = true;

    // Post form callback redirection option
    $rootScope.redirector = {};
    $rootScope.redirector.param = {};
    $rootScope.redirector.show = false;

    mm.addListener(function(m) {
        $rootScope.safeApply(function() {
            $rootScope.isMobile = (m.matches) ? true : false;
        });
    });

    $scope.storedVariables = {
        ordersList : null
    };

    //Legacy support
    $timeout(function(){
        $.core.main.initialize();
    }, 100, false);

    // Set the resolved items to be exposed to the rest of the app
    // NOTE: this is resolved at the app level so that it beats any other race condition of other promises
    NavMainFactory.setNavItems(navItems);
    AppFactory.setServices(services.plain());
    AppFactory.setDataTypes(dataTypes.plain());
    DateRangeFactory.setRelativeDateRanges(relativeDateRanges.plain());
    UIFactory.setThemeColors(themeColors.plain());
    AppFactory.setBrandMappings(brandMappings);
    AppFactory.setPageTitle();


    // Set daterange from session backend
    AppFactory.setDateRange(daterange.start, daterange.end, daterange.relative_date_range);
    AppFactory.setComparisonDateRange(daterange.comparison_start, daterange.comparison_end, daterange.comparison_active);

    // Make sure all templated directives are loaded
    initAngularTemplatedDirectives($templateCache);

    // Reset any factory specific setting
    DashboardFilterPanelFactory.resetFilterOptionList();
}

/**
 * @ngInject
 */
function NavController(
    $rootScope,
    $scope,
    LoginFactory,
    UIFactory,
    ClusterService
) {
    $scope.triggerImpersonationModal = function() {
        UIFactory.showModal('user-impersonation-modal');
    };

    $scope.triggerUnimpersonation = function() {
        LoginFactory.unimpersonateUser();
    };

    $scope.triggerImageUploadModal = function() {
        UIFactory.showModal('image-upload-modal');
    };

    $scope.logout = function(){
        LoginFactory.logout();
        $scope.removeCache();
    };

    $scope.removeCache = function(){
        ClusterService.chosenCluster = null;
        ClusterService.clusterId = null;
        $rootScope.userRole = null;
    }
}

/**
 * @ngInject
 */
function RightFrameController() {
    // NOTHING TO DO
}

//
// Footer controller
//
function FooterController() {
    //Intercept any away navigation if user has started to fill out form
    $.core.main.formNavAway();
    //Sets up bindings for form submit events
    $.core.main.initFooter();
}